import { Inject, Injectable } from '@angular/core';
import { UrlUtils } from '@ddt-web/url';

import { BootstrapOptions } from './bootstrap-options.interface';

@Injectable({
	providedIn: 'root'
})
export class BaseHrefRetrieverService {

	constructor(
		@Inject('options') private options: BootstrapOptions
	) { }


	public getBaseHref(): string {
		let baseHref = this.options.baseHref || '/';

		if (this.options.isHtml5Strategy && !UrlUtils.isDevMode()) {
			baseHref = window['BLK']?.appContainerRootPage ?? window.location.origin + window.location.pathname;
		}

		return baseHref;
	}

}
